export const calculateProcessingFeeCents = ({
  catchMarkupFixedCents = 0,
  catchMarkupPercentage = 0,
  currency,
  subtotalAmountCents,
  processingFeeRates,
}: {
  catchMarkupFixedCents?: number
  catchMarkupPercentage?: number
  currency: string
  subtotalAmountCents: number
  processingFeeRates: Record<string, { percentage: number; fixedCents: number }>
}) => {
  const rate = processingFeeRates[currency.toUpperCase()]

  if (!rate || subtotalAmountCents <= 0) return 0

  const percentage = Number(rate.percentage) + Number(catchMarkupPercentage)
  const fixedCents = Number(rate.fixedCents) + Number(catchMarkupFixedCents)

  return Math.round((subtotalAmountCents * percentage) / 100) + fixedCents
}
